<script>
  import Block from './block.svelte';
  import Row from './row.svelte';

  export let name = 'popupWin';
  export let showing = false;  // bind:showing to control popup
  export let backgroundColor = 'rgba(0, 0, 0, 0.5)';
  export let center = true;    // ignore x, y when center is true
  export let top = undefined;
  export let left = undefined;
  export let right = undefined;
  export let bottom = undefined;
  export let clickDismiss = true;
  export let zIndex = 999;
  

  function onBgClick(e) {  // TODO: 鼠标划过也会触发
    if (!showing || !clickDismiss) return;
    showing = false;
  }

  function onInnerClick(e) {
    e.stopPropagation();  // avoid inner click trigger dismiss
  }
    
</script>

{#if showing}
<Block
  name={name}
  {zIndex}
  position=fixed
  top=0
  left=0
  right=0
  bottom=0
  backgroundColor={backgroundColor}
  on:click={onBgClick}
>
  {#if center}
  <Row align=center xAlign=center width=100% height=100%>
    <Block
      pointerEvents=auto
      on:click={onInnerClick}
    >
      <slot></slot>
    </Block>
  </Row>
  {:else}
  <Block position=absolute {top} {left} {right} {bottom} pointerEvents=auto
    bindSize={true}
    on:click={onInnerClick}
  >
    <slot></slot>
  </Block>
  {/if}

</Block>
{/if}
